import {Feature} from "./Feature";
import {Product} from "./Product";
import { FeatureSpecial } from "./FeatureSpecial";
import { ImageSoucre } from "./ImageSource";

interface Grill {
    path:string,
    features:Feature[],
    product:Product
}

export class ModelControler{

    public static instance = new ModelControler();
    private product:Grill[] = [
        {
            path:"Scenes/PGblueprint.json",
            features:[
                new Feature("Grilldeckel", new Product('01020048', "Grilldeckel") ,true, [ImageSoucre.instance.Deckelnone, ImageSoucre.instance.Deckel], ["Garhaube", "Garhaube_Aufsatz"], ["Windfang"]),
                new Feature("Unterschrank", new Product('01020502', "Unterschrank"),true, [ImageSoucre.instance.Unterschrannknone, ImageSoucre.instance.Unterschrannk], ["Unterschrank"]),
                new Feature("Gasflaschenhalter", new Product('01020232', "Gasflaschenhalter"),false, [ImageSoucre.instance.Gashalternone, ImageSoucre.instance.Gashalter], ["Gasflaschenhalterung"]),
                new Feature("Drehspieß", new Product('01020242', "Drehspieß"),false, [ImageSoucre.instance.Drehspiessnone, ImageSoucre.instance.Drehspiess], ["Spiessbraten"]),
                new FeatureSpecial("Tischbrenner-Seitenablage",new Product('01020540', "Tischbrenner"),new Product('01020022', "Ablagetisch"),  false, [ImageSoucre.instance.Tischbrennernone, ImageSoucre.instance.Seitenablage, ImageSoucre.instance.Tischbrenner], ["Seitenablage_Default","Tischbrenner"]),
                new Feature("Schutzhaube", null, false, [], [])
            ],
            product: new Product('01010240', "PremioGas")
        },
        {
            path:"Scenes/PGXLblueprint.json",
            features:[
                new Feature("Grilldeckel", new Product('01020049', "Grilldeckel"), true, [ImageSoucre.instance.XLDeckelnone, ImageSoucre.instance.XLDeckel], ["Garhaube_XL", "Garhaube_XL_Aufsatz"], ["Windfang_XL"]),
                new Feature("Unterschrank",new Product('01020503', "Unterschrank"), true, [ImageSoucre.instance.XLUnterschrannknone, ImageSoucre.instance.XLUnterschrannk], ["Unterschrank_XL"]),
                new Feature("Gasflaschenhalter",new Product('01020233', "Gasflaschenhalter"), false, [ImageSoucre.instance.XLGashalternone, ImageSoucre.instance.XLGashalter], ["Gasflaschenhalterung_XL"]),
                new Feature("Drehspieß",new Product('01020243', "Drehspieß"), false, [ImageSoucre.instance.XLDrehspiessnone, ImageSoucre.instance.XLDrehspiess], ["Spiessbraten_XL"]),
                new FeatureSpecial("Tischbrenner-Seitenablage",new Product('01020541', "Tischbrenner"),new Product('01020023', "Ablagetisch"),  false, [ImageSoucre.instance.XLTischbrennernone, ImageSoucre.instance.XLSeitenablage, ImageSoucre.instance.XLTischbrenner], ["Seitenablage_XL_Default", "Tischbrenner_XL"]),
                new Feature("Schutzhaube",null, false, [], [])
            ],
            product: new Product('01010250', "PremioGasXL")
        }
    ]
    private currentProduct:Grill = this.product[0];

    private constructor(){
        this.currentProduct = this.product[0];
    }

    public toggleFeature(name:string, indicator?:string){
        let feat = this.currentProduct.features.find(elem => elem.getName() === name);
        if(feat){
            // console.log("FOUND FEATURE")
            feat.toogleModel(indicator);
        }
    }

    public getFeature(name:string):Feature{
        let feat = this.currentProduct.features.find(elem => elem.getName() === name);
        return feat;
    }

    public getFeatures():Feature[]{
        return this.currentProduct.features;
    }

    public getCurrentProductPath(){
        return this.currentProduct.path;
    }

    public setCurrentProduct(index:number):boolean{
        if(this.product[index] === this.currentProduct){
            return false;
        }
        this.currentProduct = this.product[index];
        return true;
    }

    public getCurrentProduct():Grill{
        return this.currentProduct;
    }
}

